const panelCollapseDirective = () => {
  return {
    restrict: 'A',
    link(scope, el) {
      el.on('click', () => {
        el[0].querySelector('.panel-collapse').classList.toggle('collapse');
      });
    }
  }
};

export default panelCollapseDirective;



// WEBPACK FOOTER //
// ./js/containers/core/directives/panelCollapse.js